// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-0-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 9V15C8 17.2091 9.79086 19 12 19C14.2091 19 16 17.2091 16 15V9C16 6.79086 14.2091 5 12 5C9.79086 5 8 6.79086 8 9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers01Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-0-1',
    ref,
    icon: element,
  },
));

Numbers01Icon.displayName = 'Numbers01Icon';

export default Numbers01Icon;
